import NodeTypeCrud from '../views/NodeType/Crud'
import NodeTypeAdd from '../views/NodeType/Add'
import NodeCrud from '../views/Node/Crud'
import NodeAdd from '../views/Node/Add'
import NodeAdmin from '../views/Node/Admin'
import DisciplineConfig from '../views/Node/DisciplineConfig'
import MaterialsAdmin from '../views/Materials/Admin'

const routes = {
  path: '/nodes-module',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    // NodeType
    {
      path: '/node_types',
      name: 'list-node-types',
      component: NodeTypeCrud,
      meta: {
        pageTitle: 'nodeType.title',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'nodeType.title', active: true }],
      },
    },
    {
      path: '/node_types/add',
      name: 'NewNodeType',
      component: NodeTypeAdd,
      meta: {
        pageTitle: 'nodeType.form.titleNew',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'nodeType.form.titleNew', active: true }],
      },
    },
    {
      path: '/node_types/edit/:id?',
      name: 'EditNodeType',
      component: NodeTypeAdd,
      meta: {
        pageTitle: 'nodeType.form.titleEdit',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'nodeType.form.titleEdit', active: true }],
      },
    },

    // Node
    {
      path: '/nodes',
      name: 'list-nodes',
      component: NodeCrud,
      meta: {
        pageTitle: 'node.crud.title',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'node.crud.title', active: true }],
      },
    },
    {
      path: '/nodes/add',
      name: 'NewNode',
      component: NodeAdd,
      meta: {
        pageTitle: 'node.add.newTitle',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'node.add.newTitle', active: true }],
      },
    },
    {
      path: '/nodes/edit/:id?',
      name: 'EditNode',
      component: NodeAdd,
      meta: {
        pageTitle: 'node.add.editTitle',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'node.add.editTitle', active: true }],
      },
    },
    {
      path: '/nodes/admin/:nodeId',
      name: 'AdminNode',
      component: NodeAdmin,
      meta: {
        pageTitle: 'node.admin.pageTitle',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'node.admin.pageTitle', active: true }],
      },
    },
    {
      path: '/nodes/admin/:nodeId/materials',
      name: 'NodeMaterials',
      component: MaterialsAdmin,
      meta: {
        pageTitle: 'node.admin.materialsTabTitle',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'node.admin.pageTitle', to: { name: 'AdminNode' } },
          { text: 'node.admin.materialsTabTitle', active: true },
        ],
      },
    },
    {
      path: '/nodes/admin/:nodeId/discipline/:disciplineId',
      name: 'NodeDisciplineConfig',
      component: DisciplineConfig,
      meta: {
        pageTitle: 'node.actions.configureDiscipline',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'node.admin.pageTitle', to: { name: 'AdminNode' } },
          { text: 'node.actions.configureDiscipline', active: true },
        ],
      },
    },
    {
      path: '/nodes/admin/:nodeId/discipline/:disciplineId/forms/:formDefinitionId/builder',
      name: 'FormBuilder',
      component: () => import('@/views/Node/FormBuilder/Index.vue'),
      meta: {
        pageTitle: 'nodeDisciplineConfig.forms.buildFieldsTitle',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'node.admin.pageTitle', to: { name: 'AdminNode' } },
          { text: 'node.actions.configureDiscipline', to: { name: 'NodeDisciplineConfig' } },
          { text: 'nodeDisciplineConfig.forms.buildFieldsTitle', active: true },
        ],
      },
    },
  ],
}

export default routes
